module.exports = __webpack_public_path__ + "static/img/success.ca7fd284.png";